import React, {useEffect} from 'react';
import './App.css';
import {Route, Routes, useNavigate} from 'react-router-dom';
import DefaultRoute from './guards/DefaultRoutes';
import ProtectedRoute from './guards/ProtectedRoutes';
import UnprotectedRoute from './guards/UnprotectedRoutes';
import Matchboard from './pages/Matchboard';
import Mam from './pages/Mam';
import {MatchboardProvider} from './contexts/pageMatchboard';
import {ThemeProvider} from './contexts/theme';
import {createTheme, ThemeProvider as MUIThemeProvider} from "@mui/material/styles";
import MatchPage from './pages/Match';
import Dashboard from './pages/Dashboard';
import Login from './pages/Login';
import {useAuth} from "./contexts/auth";
import {setupAxiosInterceptors} from "./queries/axiosInstance"; // Import the setup component
import {SelectedEventProvider} from "./contexts/event";
import CompetitionMatchboard from "./pages/CompetitionMatchBoard";
import {MamSummaryProvider} from "./contexts/mamSummary";
import {MamInformationProvider} from "./contexts/MamInformation";
import {ActiveFiltersProvider} from "./contexts/activeFilters";
import {ClipMamSelectedProvider} from "./contexts/clipMamSelected";
import {VideoContentTagsOptionsProvider} from "./contexts/VideoContentTagsOptions";
import VideoStream from "./pages/videoStream";
import {SSEProv} from "./contexts/SSEProvider";
import AdminPage from "./pages/AdminPage";
import UserPage from "./pages/Users";
import RoleProtectedRoute from "./guards/RoleProtectedRoute";
import {UserRole} from "./types/users";

function App() {
    const auth = useAuth();
    const { isAuthenticated } = useAuth();
    const navigate = useNavigate();

    const MUITheme = createTheme({
        typography: {
            fontFamily: "'Poppins', sans-serif", // Replace with your font
        },
    });

    // AuthProvider is into index.tsx component

    setupAxiosInterceptors(auth, navigate)

    useEffect(() => {
        let intervalId: NodeJS.Timeout | null = null;


        // Start polling only if user is authenticated
        if (isAuthenticated) {
            // Verify once immediately
            auth.verifyToken();

            // Set interval for polling every 5 minutes
            intervalId = setInterval(() => {
                auth.verifyToken();
            }, 300000);
        }

        // Cleanup function to clear the interval when component unmounts
        // or when isAuthenticated changes from true to false
        return () => {
            if (intervalId) {
                clearInterval(intervalId);
            }
        };
    }, [isAuthenticated]);

    return (
        <VideoContentTagsOptionsProvider>
            <MamSummaryProvider>
                <MamInformationProvider>
                    <ActiveFiltersProvider>
                        <ClipMamSelectedProvider>
                            <SelectedEventProvider>
                                <MatchboardProvider>
                                    <ThemeProvider>
                                            <MUIThemeProvider theme={MUITheme}>
                                                <SSEProv>
                                                    <Routes>
                                                        <Route path="/login" element={<UnprotectedRoute element={<Login />} />} />
                                                        <Route path="/jobs" element={<ProtectedRoute element={<Matchboard />} />} />
                                                        <Route path="/matchboard" element={<ProtectedRoute element={<CompetitionMatchboard />} />} />
                                                        <Route path="/match" element={<ProtectedRoute element={<MatchPage />} />} />
                                                        <Route path="/dashboard" element={<ProtectedRoute element={<Dashboard />} />} />
                                                        <Route path="/assets" element={<ProtectedRoute element={<Mam />} />} />
                                                        {/*<Route path="/videoStream" element={<ProtectedRoute element={<VideoStream />} />} />*/}
                                                        <Route path="/users" element={<ProtectedRoute element={<UserPage />} />} />
                                                        <Route path="/admin" element={<RoleProtectedRoute roles={[UserRole.SuperAdmin]} element={<AdminPage />} />} />
                                                        <Route path="*" element={<DefaultRoute />} />
                                                    </Routes>
                                                </SSEProv>
                                            </MUIThemeProvider>
                                    </ThemeProvider>
                                </MatchboardProvider>
                            </SelectedEventProvider>
                        </ClipMamSelectedProvider>
                    </ActiveFiltersProvider>
                </MamInformationProvider>
            </MamSummaryProvider>
        </VideoContentTagsOptionsProvider>

    );
}

export default App;
